import { createApp } from 'vue';
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { axiosInit } from './axios-interceptor';
import HighchartsVue from 'highcharts-vue';
import router from './router'
axiosInit();
let app = createApp(App);
app.use(router);
app.use(HighchartsVue);
app.mount('#app');